// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// core & communications
import 'babel-polyfill';
import Vue from 'vue';
import Vuetify from 'vuetify';

// HTTP Handler
import VueAxios from 'vue-axios';
import http from './http';

// Vue UI 모듈
import VTooltip from 'v-tooltip';
import VueQuillEditor from 'vue-quill-editor';
import ToggleButton from 'vue-js-toggle-button';
import VueClipboards from 'vue-clipboards';
import VueScrollTo from 'vue-scrollto';
import LiquorTree from 'liquor-tree';
import Toasted from 'vue-toasted';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation';

// global components
import GlobalComponents from './GlobalComponents';
import GlobalEvent from './GlobalEvent';

// vue add-ons
import { store } from './store/store';
import router from './router';
import './filters';

import App from './App';
/* eslint-disable no-new */

import moment from 'moment';
import vueMoment from 'vue-moment';
import eventBus from '@/EventBus';
import cookies from '@/util/cookies';
import VuePlyr from 'vue-plyr';
import Uuid from 'vue-uuid';

import DialogPopup from '@/components/DialogPopup';
import VueGtag from 'vue-gtag';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import pagination from '@/components/Pagination';
import JoditEditor from '@/components/JoditEditor';
import datePicker from '@/components/DatePicker';
import timePicker from '@/components/TimePicker';
import Hotjar from 'vue-hotjar';

// include all css files
// Editor Css
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

// nprogress
import 'nprogress/nprogress.css';

// icons
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import 'material-design-iconic-font/dist/css/material-design-iconic-font.css';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import 'animate.css/animate.min.css';
import '@fortawesome/fontawesome-free/css/all.css';

// components
import 'vue-plyr/dist/vue-plyr.css'; // only if your build system can import css, otherwise import it wherever you would import your css.

// Global Scss File
import './assets/scss/_style.scss';
import './assets/styles/vuetifyCommon.scss';
import './assets/styles/common.scss';

if (window.localStorage.getItem('LOGIN_PARAM')) {
  window.localStorage.removeItem('LOGIN_PARAM');
}

Vue.use(PerfectScrollbar);
Vue.use(VTooltip);
Vue.use(VuePlyr);
Vue.use(VueScrollTo);
Vue.use(Uuid);
Vue.use(LiquorTree);

Vue.use(Toasted, {
  action: {
    icon: 'close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  },
  position: 'top-right',
  duration: 3000
});

moment.locale('kr', {
  relativeTime: {
    future: '%s 후',
    past: '%s 전',
    s: '방금',
    ss: '%d초',
    m: '1분',
    mm: '%d분',
    h: '1시간',
    hh: '%d시간',
    d: '1일',
    dd: '%d일',
    M: '1개월',
    MM: '%d개월',
    y: '1년',
    yy: '%d년'
  }
});
Vue.prototype.$moment = moment;
Vue.prototype.$cookie = cookies;

Vue.use(VueGtag, {
  config: {
    id: process.env.GOOGLE_ANALYTICS
  }
});

Vue.use(Vuetify, {
  iconfont: 'mdi'
});

Vue.config.productionTip = false;

Vue.use(VueAxios, http);

Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: function () {
      return eventBus;
    }
  }
});

// plugins
Vue.use(Vuetify, {
  theme: store.getters.selectedTheme.theme
});

Vue.use(VueQuillEditor);
Vue.use(ToggleButton);
Vue.use(VueClipboards);
Vue.use(GlobalComponents);
Vue.use(GlobalEvent);
Vue.use(Hotjar, {
  id: process.env.HOTJAR_ID
});
Vue.use(vueMoment);

Vue.component('DialogPopup', DialogPopup);
Vue.component('pagination', pagination);
Vue.component('JoditEditor', JoditEditor);
Vue.component('datePicker', datePicker);
Vue.component('timePicker', timePicker);
Vue.component('lottieAnimation', LottieAnimation);
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  created() {
    let style = document.createElement('link');
    style.type = 'text/css';
    style.rel = 'stylesheet';
    style.href = `//public-common-sdk.s3.ap-northeast-2.amazonaws.com/fonts/twc${
      process.env.NODE_ENV === 'production' ? '' : '-dev'
    }.css?timestemp=${new Date().getTime()}`;
    document.head.appendChild(style);
    document.addEventListener('beforeunload', this.handler);
  }
});



// WEBPACK FOOTER //
// ./src/main.js